import React, { useContext } from 'react';
import { ISubcategoryContext, SubcategoryContext } from '../../../subcategoryState/subcategoryContext';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

export const IsHiddenCheckbox: React.FC = () => {
	const { toggleIsHidden, isHidden, IDSelectedRestaurant } = useContext<ISubcategoryContext>(SubcategoryContext);

	return (
		<Checkbox
			checked={isHidden}
			onChange={toggleIsHidden}
			disabled={!IDSelectedRestaurant}
			data-test="IsHiddenCheckbox">
			<Text translationNameSpace="listing" translationKey="isHiddenFemaleLabel" asFragment={true} />
		</Checkbox>
	);
};
